import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import EducacaoService from '../../../../../../services/contasEducacao-auth';
import { Link, useParams, Navigate } from 'react-router-dom';
import Moment from 'moment';


const ReceitaEduc = () => {
    let { id } = useParams()

    const [fonte, setFonte] = useState("");
    const [descricao, setDescricao] = useState("");
    const [data, setData] = useState("");
    const [valor, setValor] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchReceita(id) {
        const response = await EducacaoService.receitaEdit(id);
        setFonte(response.data["fonte"]);
        setDescricao(response.data["descricao"]);
        setValor(response.data["valor"]);
        setData(Moment(response.data["data"]).utc(false).format("yyyy-MM-DD"));
    }

    useEffect(() => {
        fetchReceita(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const receita = await EducacaoService.editarReceita(id, {
                fonte: fonte,
                descricao: descricao,
                data: data,
                valor: valor
            })
            if (receita.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="fonte">
                                <FloatingLabel
                                    label="Fonte"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="fonte"
                                        value={fonte}
                                        onChange={e => setFonte(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Valor Captado">
                                <FloatingLabel
                                    label="Valor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Data">
                                <FloatingLabel
                                    label="Data"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="data"
                                        value={data}
                                        onChange={e => setData(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="descricao">
                                <FloatingLabel
                                    label="Descrição"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="descricao"
                                        value={descricao}
                                        onChange={e => setDescricao(e.target.value)}
                                        as="textarea"
                                        rows={3}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/educacao/receitas/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Arrecadação editada com sucesso!</Alert>
                <Navigate to={'/restrito/educacao/receitas/listar'} />
            </Fragment>
        )
    }
}

export default ReceitaEduc;